export default {
  state: {
    partner: {},
    partner_apps: []
  }
}



// WEBPACK FOOTER //
// ./src/stores/PartnerAppsStore.js